import { render, staticRenderFns } from "./ConfusionMatrixItems.vue?vue&type=template&id=b61872e0&scoped=true"
import script from "./ConfusionMatrixItems.vue?vue&type=script&lang=js"
export * from "./ConfusionMatrixItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61872e0",
  null
  
)

export default component.exports